import { findProductHistory, ProductHistoryResult } from '~/Api/Product/History';
import { invokeApi, resolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectEventsByProductId, State } from './reducer';

export function fetchProductHistory(
	productId: string,
	page = 1,
	perPage = 100
): ThunkAction<Promise<ProductHistoryResult>, any> {
	return (dispatch) => {
		const request = dispatch(invokeApi(findProductHistory, productId, page, perPage));
		dispatch({ type: ActionTypes.request, request, productId });

		return resolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				productId,
				events: response?.items ?? null,
				pagination: response?.pagination ?? null,
			})
		);
	};
}

export function fetchMoreProductHistory(productId: string): ThunkAction<Promise<ProductHistoryResult | null>, any> {
	return async (dispatch, getState) => {
		const events = selectEventsByProductId(getState().productHistory, productId);
		if (events === null || events.pagination === null) {
			return dispatch(fetchProductHistory(productId));
		}

		const nextPage = events.pagination?.getNextPage();
		if (nextPage === null || nextPage === undefined) {
			return null;
		}

		return dispatch(fetchProductHistory(productId, nextPage));
	};
}

export function pruneProductHistory(productId: string): { type: string; productId: string } {
	return { type: ActionTypes.prune, productId };
}
